(function($) {

/*
*  new_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$el (jQuery element)
*  @return	n/a
*/

function new_map( options ) {
	var settings = $.extend( {
		el : this,
		icon : false,
        interactive : false,
        latlng : new google.maps.LatLng(0, 0),
        zoom : 16,
        styles : [],
        offset_x : 0,
        offset_y : 0,
        offset_z : 0
    }, options);

	// var
	var $el = settings.el;
	var $markers = $el.find('.marker');
	
	
	// vars
	var args = {
		zoom		: settings.zoom,
		center		: settings.latlng,
		mapTypeId	: google.maps.MapTypeId.ROADMAP,
		scrollwheel : false,
        disableDefaultUI: !settings.interactive,
        draggable   : !settings.interactive,
        styles      : settings.styles
	};
	
	
	// create map	        	
	var map = new google.maps.Map( $el[0], args);
	
	
	// add a markers reference
	map.markers = [];
	
	
	// add markers
	$markers.each(function(){
		
    	add_marker( $(this), map, settings.icon );
		
	});
	
	
	// center map
	center_map( map, settings.offset_x, settings.offset_y, settings.zoom, settings.offset_z);
	
	
	// return
	return map;
	
}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$marker (jQuery element)
*  @param	map (Google Map object)
*  @return	n/a
*/

function add_marker( $marker, map, icon ) {

	// var
	var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

	var marker_args = {
		position	: latlng,
		map			: map
	};

	if (icon != false) {
		marker_args.icon = icon;
	}

	// create marker
	var marker = new google.maps.Marker(marker_args);

	// add to array
	map.markers.push( marker );

	// if marker contains HTML, add it to an infoWindow
	if( $marker.html() )
	{
		// create info window
		var infowindow = new google.maps.InfoWindow({
			content		: $marker.html()
		});

		// show info window when marker is clicked
		google.maps.event.addListener(marker, 'click', function() {
			infowindow.open( map, marker );
		});

	}

}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	map (Google Map object)
*  @return	n/a
*/

function center_map( map, offset_x, offset_y, zoom, offset_z ) {

	// vars
	var bounds = new google.maps.LatLngBounds();

	// loop through all markers and create bounds
	$.each( map.markers, function( i, marker ){

		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

		bounds.extend( latlng );

	});

	// only 1 marker?
	if( map.markers.length == 1 )
	{
		
		// set center of map
	    map.setCenter( bounds.getCenter() );
		map.setZoom( zoom );
		
	}
	else
	{
		// fit to bounds
		map.fitBounds( bounds );

		if (offset_z != 0) {
			google.maps.event.addListenerOnce(map, 'zoom_changed', function(event) {
			    map.setZoom(map.getZoom() + offset_z);
			});
		}
	}

	if (offset_x != 0 || offset_y != 0) {
		map.panBy(offset_x, offset_y);
	}

}

/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type	function
*  @date	8/11/2013
*  @since	5.0.0
*
*  @param	n/a
*  @return	n/a
*/
// global var
var map = null;

$(document).ready(function(){

	if ($('.acf-map').length) {
		
		var custom_icon = {
		    url: glance.templateUrl + "/assets/images/map-pin.png",
		    size: new google.maps.Size(64, 96),
		    scaledSize: new google.maps.Size(32, 48),
		    origin: new google.maps.Point(0, 0),
		    anchor: new google.maps.Point(16, 48)
		};

		// Based on https://snazzymaps.com/style/38/shades-of-grey
		var styles = [
		    {
		        "featureType": "all",
		        "elementType": "labels.text.fill",
		        "stylers": [
		            {
		                "saturation": 24
		            },
		            {
		                "color": "#094630"
		            },
		            {
		                "lightness": 12
		            }
		        ]
		    },
		    {
		        "featureType": "all",
		        "elementType": "labels.text.stroke",
		        "stylers": [
		            {
		                "visibility": "on"
		            },
		            {
		                "color": "#094630"
		            },
		            {
		                "lightness": -10
		            }
		        ]
		    },
		    {
		        "featureType": "all",
		        "elementType": "labels.icon",
		        "stylers": [
		            {
		                "visibility": "off"
		            }
		        ]
		    },
		    {
		        "featureType": "administrative",
		        "elementType": "geometry.fill",
		        "stylers": [
		            {
		                "color": "#094630"
		            },
		            {
		                "lightness": -10
		            }
		        ]
		    },
		    {
		        "featureType": "administrative",
		        "elementType": "geometry.stroke",
		        "stylers": [
		            {
		                "color": "#094630"
		            },
		            {
		                "lightness": -8
		            },
		            {
		                "weight": 1.2
		            }
		        ]
		    },
		    {
		        "featureType": "landscape",
		        "elementType": "geometry",
		        "stylers": [
		            {
		                "color": "#094630"
		            },
		            {
		                "lightness": 0
		            }
		        ]
		    },
		    {
		        "featureType": "poi",
		        "elementType": "geometry",
		        "stylers": [
		            {
		                "color": "#094630"
		            },
		            {
		                "lightness": -5
		            }
		        ]
		    },
		    {
		        "featureType": "road.highway",
		        "elementType": "geometry.fill",
		        "stylers": [
		            {
		                "color": "#094630"
		            },
		            {
		                "lightness": -10
		            }
		        ]
		    },
		    {
		        "featureType": "road.highway",
		        "elementType": "geometry.stroke",
		        "stylers": [
		            {
		                "color": "#094630"
		            },
		            {
		                "lightness": -16
		            },
		            {
		                "weight": 0.2
		            }
		        ]
		    },
		    {
		        "featureType": "road.arterial",
		        "elementType": "geometry",
		        "stylers": [
		            {
		                "color": "#094630"
		            },
		            {
		                "lightness": -12
		            }
		        ]
		    },
		    {
		        "featureType": "road.local",
		        "elementType": "geometry",
		        "stylers": [
		            {
		                "color": "#094630"
		            },
		            {
		                "lightness": -9
		            }
		        ]
		    },
		    {
		        "featureType": "transit",
		        "elementType": "geometry",
		        "stylers": [
		            {
		                "color": "#094630"
		            },
		            {
		                "lightness": -7
		            }
		        ]
		    },
		    {
		        "featureType": "water",
		        "elementType": "geometry",
		        "stylers": [
		            {
		                "color": "#094630"
		            },
		            {
		                "lightness": -20
		            }
		        ]
		    }
		];

		$('.acf-map').each(function(){

			// create map
			var win_w = $(window).width();
			var offset = win_w < 640 ? 0 : -($(window).width() / 8);
			var zoom_offset = win_w < 640 ? 0 : -1;
			map = new_map( {el: $(this), icon: custom_icon, styles: styles, offset_x: offset, offset_z: zoom_offset, zoom: 13} );

		});
	}

});

})(jQuery);